import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ProtectedRoute = ({ children }: any) => {
  const auth = useAuth();
  return auth.token ? <Navigate to="/usage-report" /> : children;
};

export default ProtectedRoute;
